import { InjectionToken } from '@angular/core';

export const GRID_CONFIG = new InjectionToken<IGridConfig>("GridConfig");

export interface IGridConfig {
  gridName: string;
  initialData: any;
}
